import { useEffect, useState } from "react";
import { IValoresEtiquetas } from '../components/Interfaces/IValoresEtiquetas';
import { ses_id } from '../constants/getSesId';

export const useEtiquetas = () => {
    const [etiquetas, setEtiquetas] = useState<IValoresEtiquetas[]>([]);

    const URL = process.env.REACT_APP_API_HOST || 'environment not defined';

    useEffect(() => {
        fetch(URL+'cliente/controller/controllerEtiquetasAberturaChamado.asp?sesId='+ses_id)
            .then((result) => result.json())
            .then((data) => setEtiquetas(data));
    }, []);

    return{
        etiquetas,
    };
};